import * as React from "react";
import { StaticImage } from "gatsby-plugin-image";
import "twin.macro";

export default function Gallery() {
  return (
    <section id="impressionen" tw="py-24 px-6 bg-white">
      <div tw="container mx-auto max-w-6xl">

        {/* ── Team ──────────────────────────────────────────────── */}
        <div tw="text-center mb-12">
          <h2 tw="text-4xl lg:text-5xl font-medium text-secondary leading-tight">
            Unser <span tw="text-primary">Team</span>
          </h2>
          <p tw="mt-4 text-gray-500 text-lg max-w-xl mx-auto">
            Persönlich, zuverlässig, mit echtem Handwerk – das ist A &amp; F.
          </p>
        </div>

        <div tw="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto items-center">
          <div tw="overflow-hidden rounded-2xl shadow-lg">
            <StaticImage
              src="../images/team1.jpg"
              alt="Sheikh – Inhaber A & F Garten- und Landschaftsbau Flensburg"
              layout="fullWidth"
              aspectRatio={3 / 4}
              objectFit="cover"
              objectPosition="top"
            />
          </div>
          <div>
            <h3 tw="text-2xl font-medium text-secondary mb-4">
             Asmar und sein Team
            </h3>
            <p tw="text-gray-600 text-lg leading-relaxed mb-4">
              Asmar und sein Team stehen seit Jahren für handwerkliche
              Sorgfalt und persönlichen Service in Flensburg und Umgebung.
            </p>
            <p tw="text-gray-600 text-lg leading-relaxed">
              Kein anonymes Unternehmen – sondern ein direkter Ansprechpartner,
              der zu Ihnen kommt, zuhört und dann erst loslegt. Kein Angebot
              ohne Besichtigung vor Ort.
            </p>
          </div>
        </div>

        {/* ── Impressionen ──────────────────────────────────────── */}
        <div tw="text-center mt-24 mb-12">
          <h2 tw="text-4xl lg:text-5xl font-medium text-secondary leading-tight">
            Impressionen unserer{" "}
            <span tw="text-primary">Arbeit</span>
          </h2>
          <p tw="mt-4 text-gray-500 text-lg max-w-xl mx-auto">
            Echte Projekte aus Flensburg und Umgebung.
          </p>
        </div>

        {/* Muster: full → 2er → full → 2er → ... */}
        <div tw="grid grid-cols-2 gap-2">

          {/* 1 – Full */}
          <div tw="col-span-2 overflow-hidden rounded-xl">
            <StaticImage
              src="../images/11.jpg"
              alt="Gepflegter Garten mit Frühlingsblüten – A & F Galabau Flensburg"
              layout="fullWidth"
              aspectRatio={16 / 9}
              objectFit="cover"
            />
          </div>

          {/* 2 – Zwei nebeneinander */}
          <div tw="overflow-hidden rounded-xl">
            <StaticImage
              src="../images/w12.jpg"
              alt="Baumschnitt mit Hebebühne – A & F Garten- und Landschaftsbau"
              layout="fullWidth"
              aspectRatio={4 / 3}
              objectFit="cover"
            />
          </div>
          <div tw="overflow-hidden rounded-xl">
            <StaticImage
              src="../images/w4.jpg"
              alt="Gartengestaltung mit Gartenhaus und Hochbeet – Flensburg"
              layout="fullWidth"
              aspectRatio={4 / 3}
              objectFit="cover"
            />
          </div>

          {/* 3 – Full */}
          <div tw="col-span-2 overflow-hidden rounded-xl">
            <StaticImage
              src="../images/seventh.jpg"
              alt="Gartengestaltung am Hang – A & F Galabau Flensburg"
              layout="fullWidth"
              aspectRatio={16 / 9}
              objectFit="cover"
            />
          </div>

          {/* 4 – Zwei nebeneinander */}
          <div tw="overflow-hidden rounded-xl">
            <StaticImage
              src="../images/w1.jpg"
              alt="Pflasterarbeiten mit Graniteinfassung – A & F Galabau"
              layout="fullWidth"
              aspectRatio={4 / 3}
              objectFit="cover"
            />
          </div>
          <div tw="overflow-hidden rounded-xl">
            <StaticImage
              src="../images/w3.jpg"
              alt="Weidenzaun Sichtschutz – A & F Galabau"
              layout="fullWidth"
              aspectRatio={4 / 3}
              objectFit="cover"
            />
          </div>

          {/* 5 – Full */}
          <div tw="col-span-2 overflow-hidden rounded-xl">
            <StaticImage
              src="../images/w6.jpg"
              alt="Terrassengestaltung mit Sichtschutzzaun – Flensburg"
              layout="fullWidth"
              aspectRatio={16 / 9}
              objectFit="cover"
            />
          </div>

          {/* 6 – Zwei nebeneinander */}
          <div tw="overflow-hidden rounded-xl">
            <StaticImage
              src="../images/w2.jpg"
              alt="Terrassenpflasterung mit Graniteinfassung – A & F Galabau"
              layout="fullWidth"
              aspectRatio={4 / 3}
              objectFit="cover"
            />
          </div>
          <div tw="overflow-hidden rounded-xl">
            <StaticImage
              src="../images/w7.jpg"
              alt="Pflasterarbeiten Terrassenplatten – A & F Galabau Flensburg"
              layout="fullWidth"
              aspectRatio={4 / 3}
              objectFit="cover"
            />
          </div>

          {/* 7 – Full */}
          <div tw="col-span-2 overflow-hidden rounded-xl">
            <StaticImage
              src="../images/w10.jpg"
              alt="Innenausbau Holzlamellen Wandverkleidung – A & F Galabau"
              layout="fullWidth"
              aspectRatio={16 / 9}
              objectFit="cover"
            />
          </div>

          {/* 8 – Zwei nebeneinander */}
          <div tw="overflow-hidden rounded-xl">
            <StaticImage
              src="../images/w9.jpg"
              alt="Holzlamellen Wandverkleidung fertig – A & F Galabau"
              layout="fullWidth"
              aspectRatio={4 / 3}
              objectFit="cover"
            />
          </div>
          <div tw="overflow-hidden rounded-xl">
            <StaticImage
              src="../images/w11.jpg"
              alt="Wandverkleidung Lamellen – A & F Galabau Flensburg"
              layout="fullWidth"
              aspectRatio={4 / 3}
              objectFit="cover"
            />
          </div>

        </div>
      </div>
    </section>
  );
}
